//#region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from "constants/general";

//#endregion

//-----------------------------------------------------------------
function validate(content, validation_info) {
  //-----------------------------------------------------------------
  const has_validation = !!validation_info;
  const has_content    = content !== '';

  if( !has_validation || !has_content ) {
    return { content, status: SUCCESS_CODE };
  }

  validation_info = normalizeValidationInfo( validation_info );

  const result = format( content, validation_info );

  if (result.status !== FAILURE_CODE && (validation_info.Min !== '' || validation_info.Max !== '')) {
    handleMinMax(result, validation_info.Min, validation_info.Max);
  }

  return result;
};

//-----------------------------------------------------------------
function normalizeValidationInfo( info ) {
  //-----------------------------------------------------------------
  // Set defaults
  const normalized_info = {
    Max                  : null  ,
    Min                  : null  ,
    ForceDecimals        : false ,
    IsStrictNoOfDecimals : false ,
    StandardNoOfDecimals : 2     ,
  };

  // ForceDecimals
  if ( info.ForceDecimals && info.ForceDecimals !== '') {
    normalized_info.ForceDecimals = ['YES', 'TRUE', '1' ].includes( info.ForceDecimals.toUpperCase() );
  }

  // IsStrictNoOfDecimals
  if (info.IsStrictNoOfDecimals && info.IsStrictNoOfDecimals !== '') {
    normalized_info.IsStrictNoOfDecimals = ['YES', 'TRUE', '1' ].includes( info.IsStrictNoOfDecimals.toUpperCase() );
  }

  // Max
  if (info.Max && info.Max !== '') {
    normalized_info.Max = parseFloat( info.Max );
  }

  // Min
  if (info.Min && info.Min !== '') {
    normalized_info.Min = parseFloat( info.Min );
  }

  // StandardNoOfDecimals
  if (info.StandardNoOfDecimals && info.StandardNoOfDecimals !== '') {
    normalized_info.StandardNoOfDecimals = parseInt( info.StandardNoOfDecimals );
  }

  return normalized_info;
};

//-----------------------------------------------------------------
function format(content, validation_info) { // num, force, strict
  //-----------------------------------------------------------------
  const result = {
    content: content,
    message: '',
    status: SUCCESS_CODE,
  };

  try {
    const { StandardNoOfDecimals, ForceDecimals, IsStrictNoOfDecimals } = validation_info;

    // Get the parts of the number: integer and decimal
    const value_parts = content.split( '.' );

    const has_separator_multi = value_parts.length > 2;

    if( has_separator_multi ) {
      result.status  = FAILURE_CODE;
      result.message = 'Invalid amount';
      return result;
    }

    // INTEGER
    const integer_value = value_parts[0]?.replaceAll(' ', '' );
    const integer_regex_commas = /^-?[0-9]{1,3}(,[0-9]{3}){0,3}$/;
    const integer_regex_whole  = /^-?[0-9]{0,10}$/;
    const integer_regex = new RegExp( integer_regex_commas.source + '|' + integer_regex_whole.source );

    const is_valid_integer = integer_value.match( integer_regex );

    if( !is_valid_integer ) {
      result.status  = FAILURE_CODE;
      result.message = 'Invalid amount.';
      return result;
    }

    // DECIMAL
    let decimal_value = value_parts[1] || '';
    if( ForceDecimals && decimal_value.length < StandardNoOfDecimals ) {
      decimal_value = decimal_value.padEnd( StandardNoOfDecimals, '0' );
    }

    const decimal_regex = /^([0-9]{0,10})$/;
    
    const is_valid_decimal = decimal_value?.match( decimal_regex );

    if( !is_valid_decimal ) {
      result.status  = FAILURE_CODE;
      result.message = 'Invalid amount.';
      return result;
    }

    const decimal_places = decimal_value.length;
    const has_decimal = decimal_places > 0;

    if( has_decimal && IsStrictNoOfDecimals && decimal_places !== StandardNoOfDecimals ) {
      result.status  = FAILURE_CODE;
      result.message = `There must be ${StandardNoOfDecimals} decimal places.`
      return result;
    }

    // Combine parts back together
    // The unary plus (+) operator removes any leading zeros
    // (+ '') converts it back to string
    result.content = +integer_value.replaceAll( ',', '' ) + '';
    if( decimal_value ) result.content += '.' + decimal_value;
  } catch (error) {
    console.warn( error );
  }

  return result;
};

//-----------------------------------------------------------------
function handleMinMax(result, min, max) {
  //-----------------------------------------------------------------
  const value = result.content;
  const is_below_min = min ? value < min : false;
  const is_above_max = max ? value > max : false;

  const message_min = is_below_min ? ` above ${min}` : '';
  const message_max = is_above_max ? ` below ${max}` : '';

  if( is_below_min || is_above_max ) {
    result.status = FAILURE_CODE;
    result.message = 'Value must be' + message_min + message_max;
  }

  return result;
};


export { validate };